export default {
    cptDataForm: {
        dataText: '{"value":"https://www.xdwater365.com/yhfw/login.html?_v=1.05&orgCode=xdkj"}',
        dataSource: 1,
        pollTime: 0,
        apiUrl: '/text',
        sql: 'select id from test limit 1'
    },
    attribute:{
        cptTableData: [{ "name": "值", "value": "", "namekey": "value" }],
        bgColor:'#3F99FB',
        qrColor:'#ffffff',
        qrLevel:"M",
        // width:100,
        // height:100,
    },
    interaction:{ intType: 'none'}
}